import { usePageComponents } from "@portal/hooks/usePageComponents";
import { DefaultPage } from "@portal/pages/DefaultPage/DefaultPage";
import { Route, Routes } from "react-router-dom";
import { Protected } from "./Layout/Protected/Protected";
import { PublicLayout } from "./Layout/Public/PublicLayout";
import { routePath } from "./constants/utils";

function AppRoutes() {
  const { pageComponents } = usePageComponents();
  // const { component } = useResultComponents({ status: 404 });
  return (
    <Routes>
      <Route path="/" element={<Protected />}>
        <Route index element={<DefaultPage />} />
        <Route path={routePath("PORTAL")} element={pageComponents.PORTAL}>
          <Route path={routePath("INVOICES")} element={pageComponents.PORTAL}>
            <Route
              path={routePath("INVOICE_DETAILS")}
              element={pageComponents.PORTAL}
            />
          </Route>
          <Route path={routePath("PAYMENTS")} element={pageComponents.PORTAL}>
            <Route
              path={routePath("PAYMENT_DETAILS")}
              element={pageComponents.PORTAL}
            />
          </Route>
          <Route path={routePath("DISPUTES")} element={pageComponents.PORTAL}>
            <Route
              path={routePath("DISPUTE_DETAILS")}
              element={pageComponents.PORTAL}
            />
          </Route>
          <Route
            path={routePath("CREDIT_NOTES")}
            element={pageComponents.PORTAL}
          >
            <Route
              path={routePath("CREDIT_DETAILS")}
              element={pageComponents.PORTAL}
            />
          </Route>
          <Route path={routePath("PTPs")} element={pageComponents.PORTAL}>
            <Route
              path={routePath("PTP_DETAILS")}
              element={pageComponents.PORTAL}
            />
          </Route>
          <Route
            path={routePath("DOCUMENTS")}
            element={pageComponents.PORTAL}
          />
          <Route path={routePath("PROFILE")} element={pageComponents.PORTAL} />
        </Route>
      </Route>
      <Route path="/" element={<PublicLayout />}>
        <Route path={routePath("LOGIN")} element={pageComponents.LOGIN} />
      </Route>
      {/* <Route path="*" element={component} /> */}
    </Routes>
  );
}

export default AppRoutes;
